import { AfterViewInit, Component, ElementRef, HostListener } from '@angular/core'
import { RouterLink } from '@angular/router'
import { LayoutService } from '@core/services/common'
import { MenuToggler } from './components/menu-toggler'
import { NotificationDropdown } from './components/notification-dropdown'
import { SimpleUserDropdown } from './components/simple-user-dropdown'

@Component({
  selector: 'app-topbar',
  imports: [RouterLink, MenuToggler, NotificationDropdown, SimpleUserDropdown],
  template: `
    <header class="app-topbar">
      <div class="container-fluid topbar-menu">
        <div class="d-flex align-items-center gap-2">
          <!-- Topbar Brand Logo -->
          <div class="logo-topbar">
            <!-- Logo light -->
            <a routerLink="/" class="logo-light">
              <span class="logo-lg">
                <img src="assets/images/logos/logo-light.png" alt="จัดการคลังข้อมูล (CORE)" />
              </span>
              <span class="logo-sm">
                <img src="assets/images/logos/logo-light.png" alt="จัดการคลังข้อมูล (CORE)" />
              </span>
            </a>

            <!-- Logo Dark -->
            <a routerLink="/" class="logo-dark">
              <span class="logo-lg">
                <img src="assets/images/logos/logo-dark.png" alt="จัดการคลังข้อมูล (CORE)" />
              </span>
              <span class="logo-sm">
                <img src="assets/images/logos/logo-dark.png" alt="จัดการคลังข้อมูล (CORE)" />
              </span>
            </a>
          </div>

          <menu-toggler />
        </div>

        <div class="d-flex align-items-center gap-2">
          <notification-dropdown />

          <simple-user-dropdown />
        </div>
      </div>
    </header>
  `,
})
export class Topbar implements AfterViewInit {
  constructor(
    public layout: LayoutService,
    private el: ElementRef
  ) {}

  ngAfterViewInit() {
    this.handleScroll()
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.handleScroll()
  }

  handleScroll() {
    const header: HTMLElement = this.el.nativeElement.querySelector('.app-topbar')

    if (!header) return

    if (window.scrollY >= 50) {
      header.classList.add('topbar-active')
    } else {
      header.classList.remove('topbar-active')
    }
  }
}
